import ReactTooltip from 'react-tooltip';
import { IBFilterSelectState, ICancellationToken } from './FilterSelect.types';
import { ISelectOption } from '../Select';

export const getPromiseWithCancel = <T>(
  promise: Promise<T> | T,
  cancellationToken: ICancellationToken
) => {
  return new Promise<T>((resolve, reject) => {
    // eslint-disable-next-line no-param-reassign
    cancellationToken.cancel = () => {
      reject(new Error('Cancelled'));
    };
    Promise.resolve(promise).then(result => {
      resolve(result);
    });
  });
};

export const getData = (
  state: IBFilterSelectState,
  setState: (state: IBFilterSelectState) => void,
  minSearchTextLength: number,
  values: (filterText: string) => Promise<ISelectOption[]> | ISelectOption[],
  clientSideFilter: boolean,
  useGroups: boolean,
  defaultOptions?: ISelectOption[]
) => {
  if (!state.searchText) {
    setState({
      ...state,
      options: defaultOptions || []
    });
    return;
  }
  if (
    state.searchText !== state.newSearchText ||
    (!state.searchText &&
      minSearchTextLength === 0 &&
      state.options.length === 0 &&
      (state.searchText ?? '').length >= (minSearchTextLength ?? 3))
  ) {
    Promise.resolve(values(state.searchText ?? ''))
      .then(resultValues => {
        setState({
          ...state,
          newSearchText: state.searchText ?? '',
          options:
            clientSideFilter &&
            resultValues &&
            resultValues.length &&
            state.searchText
              ? resultValues.filter(
                  f =>
                    f.label
                      .toUpperCase()
                      .includes((state.searchText ?? '').toUpperCase()) ||
                    (useGroups &&
                      (f.groupLabel ?? '')
                        .toUpperCase()
                        .includes((state.searchText ?? '').toUpperCase()))
                )
              : resultValues
        });
      })
      .catch((err: Error) => {
        if (err.message !== 'Cancelled') {
          setState({ ...state, newSearchText: state.searchText, options: [] });
        }
      });
  } else if (
    (state.searchText ?? '').length < (minSearchTextLength ?? 3) &&
    state.options.length
  ) {
    setState({
      ...state,
      newSearchText: state.searchText,
      options: defaultOptions || []
    });
  }
};

export const handleOnOptionClick = (
  e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  option: ISelectOption,
  state: IBFilterSelectState,
  setState: (state: IBFilterSelectState) => void,
  onSelect: (option: ISelectOption) => void
) => {
  e.stopPropagation();
  if (onSelect) {
    onSelect(option);
  }
  setState({
    ...state,
    searchText: option.groupLabel
      ? `${option.groupLabel} - ${option.label}`
      : option.label,
    selectedOption: option,
    allowShow: false
  });
  ReactTooltip.hide();
};

export const handleOnBlur = (
  state: IBFilterSelectState,
  setState: (state: IBFilterSelectState) => void
) => {
  if (state.selectedOption && state.selectedOption.value) {
    setState({
      ...state,
      allowShow: false,
      searchText: state.selectedOption.groupLabel
        ? `${state.selectedOption.groupLabel} - ${state.selectedOption.label}`
        : state.selectedOption.label,
      inFocus: false
    });
  } else {
    setState({
      ...state,
      allowShow: false,
      inFocus: false
    });
  }
};

export const handleOnInputClick = (
  state: IBFilterSelectState,
  setState: (state: IBFilterSelectState) => void
) => {
  if (state.inFocus) {
    setState({ ...state, allowShow: !state.allowShow });
  }
};
